import React from 'react';
import Alert from 'shared/components/UC/Alert';
import Button from 'shared/components/UC/Button';
import Modal from 'shared/components/UC/Modal';
import { ImportSummaryTotals } from '../../../types/bulkAssignment';
import styles from './ImportConfirmModal.module.css';

interface ImportConfirmModalProps {
  isOpen: boolean;
  applying: boolean;
  totals: ImportSummaryTotals;
  sendInvitations: boolean;
  minEvaluatorsPerApplication: number;
  onCancel: () => void;
  onConfirm: () => void;
}

const ImportConfirmModal: React.FC<ImportConfirmModalProps> = ({
  isOpen,
  applying,
  totals,
  sendInvitations,
  minEvaluatorsPerApplication,
  onCancel,
  onConfirm,
}) => {
  const pending = totals.withPartialCoverage + totals.withoutCoverage;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title="Confirmar la asignación"
      size="md"
      footer={
        <>
          <Button type="button" variant="primary" onClick={onCancel} disabled={applying}>
            Cancelar
          </Button>
          <Button
            type="button"
            variant="secondary"
            onClick={onConfirm}
            loading={applying}
            loadingLabel="Asignando..."
          >
            Confirmar asignación
          </Button>
        </>
      }
    >
      <ul className={styles.impact}>
        <li>
          Se crearán <strong>{totals.toCreate} asignaciones</strong> en{' '}
          <strong>{totals.withFullCoverage + totals.withPartialCoverage} postulaciones</strong>.
        </li>
        <li>
          <strong>{totals.evaluatorsInvolved} evaluadores</strong> recibirán al menos
          una postulación.
        </li>
        <li>
          {pending === 0
            ? `Todas quedan con ${minEvaluatorsPerApplication} evaluadores o más.`
            : `${pending} postulaciones quedarán bajo el mínimo de ${minEvaluatorsPerApplication} y habrá que completarlas a mano.`}
        </li>
      </ul>

      {sendInvitations ? (
        <Alert variant="warning">
          Se enviarán {totals.evaluatorsInvolved} invitaciones por correo. El envío no
          se puede deshacer.
        </Alert>
      ) : (
        <Alert variant="info">
          No se enviarán correos. Las asignaciones quedarán creadas y pendientes de
          invitar.
        </Alert>
      )}
    </Modal>
  );
};

export default ImportConfirmModal;
